import { render, staticRenderFns } from "./baseStationManage.vue?vue&type=template&id=b81cc472&scoped=true"
import script from "./baseStationManage.vue?vue&type=script&lang=js"
export * from "./baseStationManage.vue?vue&type=script&lang=js"
import style0 from "./baseStationManage.vue?vue&type=style&index=0&id=b81cc472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81cc472",
  null
  
)

export default component.exports